import React from 'react';
import doctorpic from "../../../../images/doctorpic.png"
import "./contact2.css"
const Contact2 = () => {
  return (
    <section className="regervation_part section_padding" id="contact">
      <div className="container">
        <div className="row align-items-center regervation_content">
          <div className="col-lg-8">
            <div className="regervation_part_iner">
              <form>
                <h2 className="section-title">Contact Us</h2>
                
                <div className="form-row">
                <p>Reach out to Doctor Care today for all your healthcare needs.</p>
                  <div className="form-group col-md-6">
                    <input type="text" className="form-control" id="inputEmail4" placeholder="Name" />
                  </div>
                  <div className="form-group col-md-6">
                    <input type="email" className="form-control" id="inputPassword4" placeholder="Email address" />
                  </div>
                  <div className="form-group col-md-6">
                    <select className="form-control" id="Select" style={{height:"50px"}}>
                      <option value="1" defaultValue>Select service</option>
                      <option value="2">Primary Care Services</option>
                      <option value="3">Emergency Care</option>
                      <option value="4">Surgery</option>
                      <option value="5">Diagnostic Services</option>
                      <option value="5">Maternity and Obstetrics</option>
                      <option value="5">Pediatrics</option>
                      <option value="5">Mental Health Services</option>
                      <option value="5">Pharmacy</option>
                      <option value="5">Others Service</option>
                    </select>
                    
                  </div>
                  {/* <div className="form-group time_icon col-md-6">
                    <select className="form-control" id="Select2" style={{height:"50px"}}>
                      <option value="" defaultValue>Time</option>
                      <option value="1">8 AM TO 10AM</option>
                      <option value="2">10 AM TO 12PM</option>
                      <option value="3">12PM TO 2PM</option>
                      <option value="4">2PM TO 4PM</option>
                      <option value="5">4PM TO 6PM</option>
                      <option value="6">6PM TO 8PM</option>
                      <option value="7">4PM TO 10PM</option>
                      <option value="8">10PM TO 12PM</option>
                    </select>
                  </div> */}
                  <div className="form-group time_icon col-md-6">
                                            
                                            {/* <span>📅</span> */}
                                        <div className="row">
                                        <div className="form-group col-md-6">
                                            <input style={{background:"transparent", width:"100%",height:"50px",border:'1px solid black'}} type="date" id="appointment_date" name="date" required />
                                            </div>    
                                            <div className="form-group col-md-6">
                                        <input style={{background:"transparent", width:"100%",height:"50px",border:'1px solid black'}} type="time" id="appointment_date" name="date" required />
                                        </div>
                                            </div>
                                            

                                            
                                        </div>
                  <div className="form-group col-md-12">
                    <textarea className="form-control" id="Textarea" rows="4" placeholder="Details"></textarea>
                  </div>
                </div>
                <div className="regerv_btn">
                  <button href="#" className="btn_2">Contact Us</button>
                </div>
              </form>
            </div>
          </div>
          <div className="col-lg-4 col-md-6">
            <div className="reservation_img">
              <img src={doctorpic} alt="" className="reservation_img_iner" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact2;
